import {
  GET_SUBSCRIPTIONS_ERROR,
  GET_SUBSCRIPTIONS_PENDING,
  GET_SUBSCRIPTIONS_SUCCESS,
  CHECKOUT_SUBSCRIPTIONS_PENDING,
  CHECKOUT_SUBSCRIPTIONS_SUCCESS,
  CHECKOUT_SUBSCRIPTIONS_ERROR,
} from "../actions/subscription";

const initialState = {
  pending: false,
  subscriptions: [],
  error: null,
};

export function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_SUBSCRIPTIONS_PENDING:
      return {
        ...state,
        pending: true,
      };
    case GET_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        pending: false,
        subscriptions: action.payload.subscriptions,
        userSubscription: action.payload.userSubscription,
      };
    case GET_SUBSCRIPTIONS_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case CHECKOUT_SUBSCRIPTIONS_PENDING:
      return {
        ...state,
        pending: true,
      };
    case CHECKOUT_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        pending: false,
        checkout: action.payload.subscriptions,
      };
    case CHECKOUT_SUBSCRIPTIONS_ERROR:
      return {
        ...state,
        pending: false,
        checkout: action.error,
      };
    default:
      return state;
  }
}

export const getSubscriptions = (state) => state.subscriptions.subscriptions;
export const getSubscriptionsPending = (state) => state.subscriptions.pending;
export const getSubscriptionsError = (state) => state.subscriptions.error;
